// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel-body[data-v-7fc35ea1] {
  padding-top: 0;
}
.add-document[data-v-7fc35ea1] {
  margin-top: 5px;
}
.filename-label[data-v-7fc35ea1] {
  position: relative;
  top: -13px;
  margin-left: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/js/netpify/components/np-upload-widget.vue","webpack://./np-upload-widget.vue"],"names":[],"mappings":"AACI;EACI,cAAA;ACAR;ADEI;EACI,eAAA;ACAR;ADEI;EACI,kBAAA;EACA,UAAA;EACA,gBAAA;ACAR","sourcesContent":["\n    .panel-body {\n        padding-top:0;\n    }\n    .add-document {\n        margin-top:5px;\n    }\n    .filename-label {\n        position: relative;\n        top: -13px;\n        margin-left:2px;\n    }\n\n",".panel-body {\n  padding-top: 0;\n}\n.add-document {\n  margin-top: 5px;\n}\n.filename-label {\n  position: relative;\n  top: -13px;\n  margin-left: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
